import { Component, ElementRef, Input, Host } from '@angular/core';

import * as _ from 'lodash';

import { RippleDirectiveBase } from '../../../button/directives/ripple.directive';

import { ListComponent } from '../../list.component';

@Component({
  selector: 'uex-list-item',
  templateUrl: './item.component.html',
  host: {
    'class': 'uex-list-item list-group-item',
    '[class.list-group-item-action]': 'clickable || hover',
    '[class.clickable]': 'clickable',
    '[class.with-ripple]': '!no_ripple'
  }
})
export class ListItemComponent extends RippleDirectiveBase {
  @Input('alignItems') public alignItems = 'center';
  @Input('alignContent') public alignContent: string = null;
  @Input('justifyItems') public justifyItems: string = null;

  @Input('clickable') private set _setClickable(clickable: boolean) {
    this._clickable = this._getAttribute(clickable, true);
  }
  @Input('hover') private set _setHover(hover: any) {
    this._hover = this._getAttribute(hover, true);
  }

  constructor(
    public elementRef: ElementRef,
    @Host() public list: ListComponent
  ) { super(elementRef); }

  private _clickable: boolean;
  private _hover: boolean;

  public get no_ripple(): boolean {
    return this._no_ripple || (this.list && !this.list.clickable);
  }

  public get clickable(): boolean {
    return this._clickable || (this.list && this.list.clickable);
  }

  public get hover(): boolean {
    return this._hover || (this.list && this.list.hover);
  }

  private _getAttribute(value: any, boolean: boolean = false): any {
    if (boolean) { return (_.isString(value) && value !== 'false') || (_.isBoolean(value) && !!value); }
    return !!value ? value : null;
  }
}
